import { useEffect, useState, useRef } from "react";
import { useParams, Navigate } from "react-router-dom";
import { track } from "@/lib/analytics";

const STORES = {
  niv: "https://nivbook.co.il/product/הספר-של-מורה-הלחימה/",
  amazon: "https://www.amazon.com/dp/B0HHXRMDC9",
  walmart:
    "https://www.walmart.com/ip/The-Book-of-The-Warriors-Teacher-Paperback-9798904187033/20609318678?classType=REGULAR",
};

export default function GoRedirect() {
  const { store } = useParams();
  const base = STORES[store];
  const fired = useRef(false);

  useEffect(() => {
    if (!base || fired.current) return;
    fired.current = true;
    const url = new URL(base);
    url.searchParams.set("utm_source", "quietsword");
    url.searchParams.set("utm_medium", "book_page");
    url.searchParams.set("utm_campaign", "book_purchase");
    url.searchParams.set("utm_content", store);
    track("click_store", { store });
    window.location.replace(url.toString());
  }, [base, store]);

  if (!base) return <Navigate to="/book" replace />;

  return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", color: "#c0b9b0", background: "#211d1a", fontFamily: "'Public Sans', sans-serif" }}>
      Redirecting to store…
    </div>
  );
}
